import React from 'react';

import ContentLoader, { Rect } from 'react-content-loader/native';
import { SCREEN_HEIGHT, SCREEN_WIDTH } from '~/utils/device';

const DEFAULT_WIDTH = SCREEN_WIDTH - 48;

const Loader: React.FC = () => {
  return (
    <ContentLoader
      animate
      width={SCREEN_WIDTH}
      height={SCREEN_HEIGHT}
      viewBox={`0 0 ${SCREEN_WIDTH} ${SCREEN_HEIGHT}`}
    >
      <Rect x="24" y="0" width={DEFAULT_WIDTH} height="65" />
      <Rect x="24" y="75" width={DEFAULT_WIDTH} height="65" />
      <Rect x="24" y="150" width={DEFAULT_WIDTH} height="65" />
      <Rect x="24" y="225" width={DEFAULT_WIDTH} height="65" />
    </ContentLoader>
  );
};

export default Loader;
